import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "../components/Reveal";

const STEPS = [
  { num: "1", title: "Before your consultation", desc: "Complete a short health discovery form and share relevant medical reports." },
  { num: "2", title: "Your consultation", desc: "A detailed virtual consultation focused on your concerns, history, lifestyle and available clinical data." },
  { num: "3", title: "Your personalised plan", desc: "A structured plan based on your priorities—not a generic protocol." },
  { num: "4", title: "Follow-up", desc: "Regular review of symptoms, adherence, laboratory trends and measurable outcomes." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="bg-ivory grain relative" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32">
      <Reveal className="max-w-2xl">
        <Eyebrow>05 · How it works</Eyebrow>
        <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          What happens when you work with us?
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={0.09 * i}>
            <div className="relative bg-white border border-line p-8 h-full hover:border-gold/60 transition-colors duration-500" data-testid={`how-step-${s.num}`}>
              <span className="font-mono text-[11px] tracking-[0.24em] text-gold">STEP {s.num}</span>
              <span className="absolute top-6 right-7 font-serif text-5xl text-forest/10">{s.num}</span>
              <h3 className="mt-5 font-serif text-xl text-ink leading-snug">{s.title}</h3>
              <p className="mt-3 text-sm text-inkmuted leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <div className="mt-14">
          <Link
            to="/health-profile"
            data-testid="how-cta-profile"
            className="inline-flex items-center rounded-full bg-forest text-ivory px-9 py-4 text-sm font-semibold tracking-wide border border-gold/40 hover:bg-forestdeep transition-colors duration-300"
          >
            Start Your Health Profile
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
